history.getState = function(){
	return {
		'url': location.href.replace(location.hash,"")
	};
};

window.History = window.history;